import type { LibraryItem } from '@/data/mock'

/**
 * The string to display for a library source wherever a citation label is
 * needed (in-doc bibliography, surgery view, export footers, etc.).
 *
 * Precedence:
 *   1. user-provided short citation override
 *   2. AI-generated short citation
 *   3. user-provided AMA citation override
 *   4. AI-generated AMA citation
 *   5. filename
 *   6. caller-provided fallback (typically the source doc id)
 *
 * The override-first ordering at each level keeps every surface in sync with
 * the user's manual edits in DocumentDetailsPanel.
 */
export function citationLabel(
  item: LibraryItem | undefined,
  fallback: string,
): string {
  if (!item) return fallback
  return (
    (item.shortCitationOverride ?? item.shortCitation) ||
    (item.amaCitationOverride ?? item.amaCitation) ||
    item.filename ||
    fallback
  )
}
